interface P { size?: "sm" | "md" }

/**
 * "Vérifier" badge awarded to users who verified their email.
 * Small pill with a shimmer gradient + subtle glow.
 */
export function VerifiedBadge({ size = "sm" }: P) {
  const pad = size === "md" ? "3px 9px" : "2px 7px";
  const fontSize = size === "md" ? 11 : 10;
  return (
    <>
      <span className="uhq-1337" style={{
        display: "inline-flex", alignItems: "center", gap: 4,
        padding: pad, fontSize, fontWeight: 800, letterSpacing: 1,
        borderRadius: 999, color: "#000",
        background: "linear-gradient(120deg,#f7ee7f 0%,#a855f7 45%,#22d3ee 100%)",
        backgroundSize: "300% 100%",
        boxShadow: "0 0 12px rgba(168,85,247,.45), inset 0 0 0 1px rgba(255,255,255,.35)",
        textShadow: "0 1px 0 rgba(255,255,255,.4)",
        animation: "uhq-shimmer 4s linear infinite",
        userSelect: "none", cursor: "help",
      }} title="Email vérifié">
        vérifier
      </span>
      <style>{`@keyframes uhq-shimmer { 0% { background-position:0% 50%; } 100% { background-position:300% 50%; } }`}</style>
    </>
  );
}
